// Handle customsize in PDP
(function () {
  const productFormInput = document.querySelectorAll(
    "product-info .product-form__input",
  );
  if (productFormInput.length < 2) return;
  const customSizeItem = document.querySelectorAll(".custom-select-size__item");

  function getDisabledStatus(listSelectors) {
    const lists = [];

    // collect all lists of inputs
    document.querySelectorAll(listSelectors).forEach(function (elm) {
      lists.push(Array.from(elm.querySelectorAll("input")));
    });

    const result = [];
    const len = Math.min(...lists.map((list) => list.length));

    for (let i = 0; i < len; i++) {
      let isDisabled = false;

      for (let j = 0; j < lists.length; j++) {
        if (lists[j][i].classList.contains("disabled")) {
          isDisabled = true;
          break; // no need to check further lists
        }
      }
      result.push(isDisabled);
    }
    return result;
  }

  function defaultSelect() {
    const oneRowSize = document.querySelector(".one-row-size");
    if (!oneRowSize) return;
    customSizeItem.forEach((elm, idx) => {
      if (oneRowSize && !arrDisabledStatus[idx]) {
        console.log("elm", elm);
        elm.click();
        return false;
      }
    });
  }

  const arrDisabledStatus = getDisabledStatus(".product-form__input");

  customSizeItem.forEach((elm, idx) => {
    if (arrDisabledStatus[idx]) {
      elm.classList.add("disabled");
    }

    elm.addEventListener("click", (e) => {
      const customSize = e.currentTarget;
      customSizeItem.forEach((item) => item.classList.remove("is-active"));
      customSize.classList.add("is-active");
      const value = customSize.dataset.value;
      setTimeout(() => {
        const label = document.querySelector(
          `variant-radios label[data-value="${value}"]`,
        );
        if (label) label.click();
      }, 150);
    });
  });

  defaultSelect();
})();

// Handle promotion block behavior in PDP when page load
(function () {
  const productPromotionItems = document.querySelectorAll(
    ".product__promotion .product__promotion-item",
  );
  productPromotionItems.forEach((productPromotionItem) => {
    const promotionLink = productPromotionItem.querySelector(
      ".product__promotion-item__link",
    );
    const url = promotionLink.getAttribute("href");

    productPromotionItem?.addEventListener("click", (e) => {
      if (document.readyState !== "complete") {
        e.preventDefault();
      } else if (document.readyState === "complete") {
        e.preventDefault();

        removeItemFromSessionstorage("scrollPosition-");
        removeItemFromSessionstorage("cacheContentCollection-");
        removeItemFromSessionstorage("cacheCurrentPageContent-");
        removeItemFromSessionstorage("cacheNextUrl-");
        removeItemFromSessionstorage("cacheCurrentCountCollection-");
        removeItemFromSessionstorage("cacheCountCollection-");
        removeItemFromSessionstorage("cacheLoadMoreBtnCollection-");

        setTimeout(() => {
          window.location.href = url;
        }, 3e2);
      }
    });
  });

  function removeItemFromSessionstorage(keyString) {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.includes(keyString)) {
        sessionStorage.removeItem(key);
      }
    }
  }
})();
